import type { FunctionComponent, MouseEvent } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { gameStateActions } from '../../../../store/slices/game/slice';
import { Icons } from '../../../icons/iconNames';
import { GameButtonProps, GameButtonWithTooltip } from '../../gameButton/gameButton';

export interface StatisticsControlConnectedProps extends Omit<GameButtonProps, 'icon'> {}
export const StatisticsControlConnected: FunctionComponent<StatisticsControlConnectedProps> = ({
  onClick,
  ...rest
}) => {
  const dispatch = useCoreDispatch();
  const isStatisticsOpen = useGameStateSlice.getOpenedLeftDrawer() === 'recentResults';

  const handleStatisticsToggle = (event: MouseEvent<HTMLButtonElement>): void => {
    if (!isStatisticsOpen) {
      Logger.logEvent('click', 'openRecentResults', Date.now(), 1, '', false);
    }
    dispatch(gameStateActions.setOpenLeftDrawer(!isStatisticsOpen ? 'recentResults' : null));
    onClick?.(event);
  };

  return (
    <GameButtonWithTooltip
      icon={Icons.Statistics}
      border
      active={isStatisticsOpen}
      onClick={handleStatisticsToggle}
      {...rest}
      tooltipOptions={{
        text: 'STATISTICS',
        disabled: isStatisticsOpen,
      }}
    />
  );
};
